import React, { memo } from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { OcplcKmatLockingQuery } from 'actions/ocplcAction';
import { isPLCAdmin } from 'pages/Utils/OcplcUtil';
import { snackBar } from 'actions/modelActions';
import { LOCAL_STORAGE_KEY, saveToLocalStorage, SELECTED_ROW } from 'utils/localStorageUtil';

const OcplcMenuList = memo(({ row, loginUserEmailId, userRole }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    const { kmatId, status, productGroup, productLineID ,lastModifiedTS } = row;
    const ocplcAdmin = isPLCAdmin(userRole);

    const handleClick = async (type) => {
        if (!kmatId || !productLineID || !productGroup) {
            dispatch(snackBar(true, `Product Line is empty for KMAT - ${kmatId}`, 'error'));
        } else {
            if (type === 'edit') {
                const isError = await dispatch(OcplcKmatLockingQuery(kmatId, ocplcAdmin, loginUserEmailId, lastModifiedTS, status));
                if (isError) return;
                saveToLocalStorage(LOCAL_STORAGE_KEY, row);
                saveToLocalStorage(SELECTED_ROW, row);
                localStorage.setItem('ocplc_source', 'edit');
                navigate(
                    `/ocplc/${type}`,
                    { state: { source: 'edit' } }
                );
            } else if (type === 'viewRecord') {
                localStorage.setItem('ocplc_source', 'viewRecord');
                saveToLocalStorage(SELECTED_ROW, row);
                navigate(
                    `/ocplc/${type}`,
                    { state: { source: 'viewRecord' } }
                );
            }
        }
    };

    return (
        <Box>
            <Button onClick={() => handleClick('viewRecord')} aria-label="view record" startIcon={<VisibilityIcon />} />
            <Button onClick={() => handleClick('edit')} aria-label="edit" startIcon={<EditIcon />} />
        </Box>
    );
});

export default OcplcMenuList;